import userService from '@/service/user/userService';
import {SET_USER_INFO, SET_LOGIN_STATE} from "../mutation-types";
import {getLoginUser} from '@/service/authentication/authentication'; // 加载层


let CHECK_SESSION_INTERVAL_ID;

/**
 * {
      account: "",
      areaId: "",
      dev_member_id: "",
      group_code: "",
      id: 0,
      lock_reason: "",
      lock_status: 0,
      lock_time: 0,
      loginTerminal: "",
      memberCode: "",
      memberId: "",
      memberName: "",
      memberType: 0,
      memberUserType: 1,
      name: "",
      parent_member: "",
      password: "",
      sessionId: "",
      shopId: "",
      status_id: 1,
      superAdmin: false,
      type_id: 1,
      userGroups: []
    }
 */
export default {
  namespaced: true,
  state: {
    loginUser: null,
    isLogin: null
  },
  mutations: {
    [SET_USER_INFO](state, data) {
      state.loginUser = data
    },
    [SET_LOGIN_STATE](state, data) {
      state.isLogin = data
    }
  },
  actions: {
    userLogin({commit}, params) {
      return new Promise((resolve, reject) => {
        userService.login(params)
            .then(resp => {
              commit(SET_LOGIN_STATE, 0)
              commit(SET_USER_INFO, resp.data.user)
              resolve()
            })
            .catch(e => reject(e))
      })
    },
    userLogout({commit}, params) {
      return new Promise((resolve, reject) => {
        userService.logout(params)
            .then(resp => {
              commit(SET_USER_INFO, {})
              commit(SET_LOGIN_STATE, 2002)
              resolve()
            })
            .catch(e => reject(e))
      })
    },


    pollCheck({commit}, params) {
      // console.log('pollCheck')
      if (CHECK_SESSION_INTERVAL_ID == null) {
        // console.log('开启轮询检查会话...')
        CHECK_SESSION_INTERVAL_ID = setInterval(() => {
          userService.checkLogin()
              .then(resp => {
                if (resp != 0) {
                  clearInterval(CHECK_SESSION_INTERVAL_ID)
                  CHECK_SESSION_INTERVAL_ID = null
                }
                commit(SET_LOGIN_STATE, resp)
              })
              .catch(resp => {
                clearInterval(CHECK_SESSION_INTERVAL_ID)
                CHECK_SESSION_INTERVAL_ID = null
                if (resp != undefined) {
                  commit(SET_LOGIN_STATE, resp)
                }
              })
        }, 2000)
      } else {
        console.log('轮询检查会话已开启，无非再次开启')
      }
    },

    checkLogin({commit}, params) {
      // 开启轮询会话检查
      return new Promise((resolve, reject) => {
        userService.checkLogin()
            .then(resp => {
              commit(SET_LOGIN_STATE, resp)
              resolve(resp == 0)
            })
            .catch(e => {
              if (e != undefined) {
                commit(SET_LOGIN_STATE, e)
              }
              reject(e)
            })
      })
    },

  },
  getters: {
    getUserInfo: state => {
      if (!state.loginUser) {
        state.loginUser = getLoginUser()
      }
      return state.loginUser
    },

    getUserLoginState: state => {
      return state.isLogin
    },
  }
}